export const templateData = ["Họ và tên(*)", "Số điện thoại (*)\n(Mỗi số điện thoại cách nhau dấu ,)", "Email \n(Mỗi email các nhau dấu ,)", "CMND/CCCD", "Địa chỉ", "Nguồn"]
